import React from 'react'
import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { BloodlineDiseaseType } from '../../../../types';

const BloodlineDiseasesInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  return (
    <Container>
      <FormInfoWrapper>
        <p>In my family bloodline there are specific diseases</p>
        <ol>
          {selectedClient?.bloodlineDiseases?.length ?
            selectedClient?.bloodlineDiseases?.map((bloodlineDisease: BloodlineDiseaseType) => (
              <li>
                {bloodlineDisease?.disease}
                <ul>
                  {bloodlineDisease?.familyMembers?.map((familyMember) => (
                    <>
                      <li>{familyMember.family_member_key}</li>
                      <ul>
                        <li>
                          <span>
                            At which age?
                          </span>
                          {familyMember.death.age}
                        </li>
                        <li>
                          <span>
                            What was the cause?
                          </span>
                          {familyMember.death.cause}
                        </li>
                      </ul>
                    </>
                  ))}
                </ul>
              </li>
            ))
            : (
              <em>None</em>
            )}
        </ol>
      </FormInfoWrapper>
    </Container>
  )
}

export default BloodlineDiseasesInfo

